import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ClientInfo from "./ClientInfo";
import { useSpring, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

const clients = [
  { name: "Adidas", logo: "./adidas.png" },
  { name: "Elcarte", logo: "./elcarte.jpg" },
  { name: "Levi's", logo: "./levis.png" },
  { name: "Lotto", logo: "./lotto.png" },
  { name: "Nike", logo: "./nike.png" },
  { name: "North Bend", logo: "./northbend.png" },
  { name: "Primato", logo: "./primato.jpg" },
  { name: "Reebok", logo: "./reebok.png" },
  { name: "Team Sportia", logo: "./team-sportia.png" },
  // Add more clients as needed
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
  },
};

const AnimatedNumber = ({ target = 0, duration = 2000, suffix = "" }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });
  const { number } = useSpring({
    from: { number: 0 },
    to: { number: inView ? target : 0 },
    config: { duration },
    pause: !inView,
  });

  return (
    <animated.span ref={ref} className="text-4xl font-bold text-background-secondary">
      {number.to((n) => `${Math.floor(n)}${suffix}`)}
    </animated.span>
  );
};

const ClientCarousel = () => {
  return (
    <section className="bg-background-primary py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 text-left md:pr-8 mb-8 md:mb-0">
          <h3 className="text-text-primary text-lg font-semibold mb-2">Our Clients</h3>
          <h2 className="text-3xl font-bold mb-4 text-primary">
            Trusted by Leading <br />
            Brands Worldwide
          </h2>
          <p className="text-text-primary mb-6">
            We take pride in serving a diverse portfolio of clients, ranging from global giants to innovative startups. Our commitment to quality and reliability has made us the preferred choice for businesses across various industries.
          </p>

          <div className="flex items-center">
            <AnimatedNumber target={50} suffix="+" />
            <div className="mx-4 border-l-2 border-text-secondary h-full"></div>
            <div className="text-text-primary text-lg font-medium">
              <span>Satisfied</span>
              <br />
              <span className="font-bold">Global Clients</span>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/2">
          <Carousel
            responsive={responsive}
            rewind={false}
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={false}
            sliderClass=""
            slidesToSlide={1}
            swipeable
            additionalTransfrom={0}
            arrows
            autoPlay
            autoPlaySpeed={2000}
            centerMode={false}
            className=""
            containerClass="container-with-dots"
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite
            itemClass="px-2"
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
          >
            {clients.map((client, index) => (
              <ClientInfo key={index} client={client} />
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default ClientCarousel;